import React from 'react'

interface LogoProps {
  variant?: 'horizontal' | 'vertical' | 'icon' | 'white'
  showTagline?: boolean
  className?: string
  iconSize?: number
}

export const TunasIcon: React.FC<{ size?: number; className?: string; isWhite?: boolean }> = ({
  size = 36,
  className = '',
  isWhite = false,
}) => {
  const sunColor = isWhite ? '#FFFFFF' : '#FBBF24'
  const leftLeafColor = isWhite ? 'rgba(255,255,255,0.85)' : '#10B981'
  const rightLeafColor = isWhite ? '#FFFFFF' : '#0F766E'
  const stemColor = isWhite ? 'rgba(255,255,255,0.9)' : '#0F766E'

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`inline-block flex-shrink-0 ${className}`}
      aria-hidden="true"
    >
      {/* Sun / Matahari: Lingkaran harapan & masa depan */}
      <circle cx="50" cy="18" r="11" fill={sunColor} />

      {/* Stem / Akar Tunas: Fondasi yang disiapkan hari ini */}
      <path
        d="M48 45C48 58 47 72 49 84C49.5 87 48.5 90 47 92C45.5 90 45 87 45.5 83C44.5 71 45.5 58 48 45Z"
        fill={stemColor}
      />

      {/* Left Leaf / Daun Kiri (Pertumbuhan & Proses Bertahap) */}
      <path
        d="M46 52C42 50 25 45 20 33C17 26 21 21 28 23C37 25 44 38 46 52Z"
        fill={leftLeafColor}
      />

      {/* Right Leaf / Daun Kanan (Stabilitas & Arah Menuju Masa Depan) */}
      <path
        d="M49 48C53 46 72 38 78 28C82 21 78 16 71 18C59 21 51 35 49 48Z"
        fill={rightLeafColor}
      />
    </svg>
  )
}

export const BekalNantiLogo: React.FC<LogoProps> = ({
  variant = 'horizontal',
  showTagline = false,
  className = '',
  iconSize = 36,
}) => {
  const isWhite = variant === 'white'

  if (variant === 'icon') {
    return <TunasIcon size={iconSize} className={className} isWhite={isWhite} />
  }

  if (variant === 'vertical') {
    return (
      <div className={`flex flex-col items-center text-center ${className}`}>
        <TunasIcon size={iconSize * 1.5} isWhite={isWhite} />
        <span
          className={`mt-2 text-2xl font-extrabold tracking-tight font-sans ${
            isWhite ? 'text-white' : 'text-[#0F172A]'
          }`}
        >
          Bekal<span className={isWhite ? 'text-teal-200' : 'text-[#0EA5A4]'}>Nanti</span><span className={isWhite ? 'text-teal-300' : 'text-[#0F766E]'}>.ID</span>
        </span>
        {showTagline && (
          <span
            className={`text-xs mt-1 font-medium ${
              isWhite ? 'text-teal-100' : 'text-[#64748B]'
            }`}
          >
            Persiapan Hari Ini, Peluang Lebih Besar Nanti
          </span>
        )}
      </div>
    )
  }

  // Horizontal variant (default)
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <TunasIcon size={iconSize} isWhite={isWhite} />
      <div className="flex flex-col">
        <span
          className={`text-xl font-extrabold tracking-tight leading-none font-sans ${
            isWhite ? 'text-white' : 'text-[#0F172A]'
          }`}
        >
          Bekal<span className={isWhite ? 'text-teal-200' : 'text-[#0EA5A4]'}>Nanti</span><span className={isWhite ? 'text-teal-300' : 'text-[#0F766E]'}>.ID</span>
        </span>
        {showTagline && (
          <span
            className={`text-[10px] mt-0.5 font-medium leading-none tracking-tight ${
              isWhite ? 'text-teal-100' : 'text-[#64748B]'
            }`}
          >
            Persiapan Hari Ini, Peluang Lebih Besar Nanti
          </span>
        )}
      </div>
    </div>
  )
}

export default BekalNantiLogo
